import { inject, Pipe, PipeTransform } from '@angular/core'
import { OrderInterface } from '@modules/orders-module/interfaces/order.interface'
import { TranslateService } from '@ngx-translate/core'
import { StocksOrdersHelperService } from '@modules/stocks-module/orders/services/stocks-orders-helper.service'

@Pipe({
	name: 'titleOrderType',
})
export class TitleOrderTypePipe implements PipeTransform {
	private readonly _translateService: TranslateService = inject<TranslateService>(TranslateService)
	private readonly _ordersStocksHelperService: StocksOrdersHelperService =
		inject<StocksOrdersHelperService>(StocksOrdersHelperService)

	transform(order: OrderInterface | null, isDetailed: boolean = false): string {
		if (!order) return ''

		const hasTp: boolean = !!this._ordersStocksHelperService.findTakeProfit(order)
		const hasSl: boolean = !!this._ordersStocksHelperService.findStopLoss(order)

		if (isDetailed && (hasTp || hasSl)) {
			const label: string = this._translateService.instant('orders.complexOrders')
			return `${label} (${order.order_class?.toUpperCase() || ''})`
		}

		if (order.order_attribute) {
			return order.order_attribute
		}

		if (order.type) {
			return this._translateService.instant('orders.types.' + order.type)
		}

		return ''
	}
}
